import Path from 'assets/icons/base/Path';
import PropTypes from 'prop-types';
import React from 'react';
import SVG from 'assets/icons/base/SVG';
import styled from 'libs/styled';

const Wrapper = styled('div')``;

const Arrow = ({
    color = 'black',
    handleClick = () => null,
    height = '18px',
    viewBox = '0 0 18 18',
    width = '18px',
    ...props
}) => (
    <Wrapper display="contents" height={height} width={width} onClick={handleClick}>
        <SVG height={height} viewBox={viewBox} width={width} fill="none" {...props}>
            <Path d="M14 9L2 2V16L14 9Z" stroke={color} />
        </SVG>
    </Wrapper>
);

Arrow.propTypes = {
    color: PropTypes.string,
    handleClick: PropTypes.func,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default Arrow;
